<template>
    <el-container id="shared-app" v-if="$route.meta.addSideNav">
        <sidenav
            v-if="hasWindowHeader"
            :isVisible="isSidebarVisible"
            @menuClick="toggleSidebar(!isSidebarVisible)"
        ></sidenav>
        <el-container>
            <el-header height="70px" class="app-header" v-if="hasWindowHeader">
                <el-row type="flex" :justify="'flex-start'" class="h-100">
                    <div class="sidenav-toggle mr-10px">
                        <el-button
                            type="text"
                            size="mini"
                            class="p-5px toggle-btn"
                            @click="toggleSidebar(!isSidebarVisible)"
                        >
                            <i class="fa fa-bars"></i>
                        </el-button>
                    </div>
                    <el-breadcrumb
                        separator-class="el-icon-arrow-right"
                        :class="$client.width > 900 ? 'pull-left' : null"
                    >
                        <el-breadcrumb-item>{{ $t('Inspection Detail') }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-row>
            </el-header>
            <el-main class="position-relative">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
    <div id="shared-app" v-else>
        <router-view />
    </div>
</template>

<script>
import sidenav from '@/main/components/sidenav/simple.vue';

export default {
    name: 'sharedentity',
    components: { sidenav },
    data() {
        return {
            isSidebarVisible: this.$client.width > 900,
        };
    },
    computed: {
        hasWindowHeader() {
            return window.hasWindowHeader !== false ? true : window.hasWindowHeader;
        },
    },
    methods: {
        toggleSidebar(flag) {
            this.isSidebarVisible = flag;
        },
    },
};
</script>

<style lang="scss">
#shared-app {
    height: 100%;
    overflow-y: auto;
}
</style>
